var _defs, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceUiUxDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    width: 1200,
    height: 800,
    role: "img",
    "aria-label": "Abstract illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "guiuxdesign",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163936"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wuiuxdesign",
    cx: 0.2,
    cy: 0.1,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83ADA9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83ADA9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ouiuxdesign",
    cx: 0.85,
    cy: 0.85,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4804",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4804",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#F5F8F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#wuiuxdesign)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#ouiuxdesign)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 180,
    r: 4.4,
    fill: "#548A85",
    fillOpacity: 0.17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 180,
    r: 4.5,
    fill: "#548A85",
    fillOpacity: 0.22
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 180,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.26
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 180,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 180,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 180,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 606,
    cy: 180,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 180,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 718,
    cy: 180,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.26
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 180,
    r: 4.5,
    fill: "#548A85",
    fillOpacity: 0.22
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 180,
    r: 4.4,
    fill: "#548A85",
    fillOpacity: 0.17
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 886,
    cy: 180,
    r: 4.3,
    fill: "#548A85",
    fillOpacity: 0.12
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 180,
    r: 4.1,
    fill: "#548A85",
    fillOpacity: 0.12
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 232,
    r: 4.5,
    fill: "#548A85",
    fillOpacity: 0.22
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 232,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.28
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 232,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 232,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.36
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 232,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.39
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 232,
    r: 4.9,
    fill: "#548A85",
    fillOpacity: 0.4
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 606,
    cy: 232,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.39
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 232,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.36
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 718,
    cy: 232,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 232,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.28
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 232,
    r: 4.5,
    fill: "#548A85",
    fillOpacity: 0.22
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 886,
    cy: 232,
    r: 4.3,
    fill: "#548A85",
    fillOpacity: 0.16
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 232,
    r: 4.2,
    fill: "#548A85",
    fillOpacity: 0.12
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 284,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.26
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 284,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 284,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.38
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 284,
    r: 4.9,
    fill: "#548A85",
    fillOpacity: 0.43
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 284,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.46
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 284,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.47
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 606,
    cy: 284,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.46
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 284,
    r: 4.9,
    fill: "#548A85",
    fillOpacity: 0.43
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 718,
    cy: 284,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.38
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 284,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 284,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.26
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 886,
    cy: 284,
    r: 4.4,
    fill: "#548A85",
    fillOpacity: 0.2
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 284,
    r: 4.3,
    fill: "#548A85",
    fillOpacity: 0.13
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 336,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.3
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 336,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.36
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 336,
    r: 4.9,
    fill: "#548A85",
    fillOpacity: 0.43
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 336,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.49
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 336,
    r: 5.1,
    fill: "#548A85",
    fillOpacity: 0.53
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 336,
    r: 5.2,
    fill: "#548A85",
    fillOpacity: 0.55
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 606,
    cy: 336,
    r: 5.1,
    fill: "#548A85",
    fillOpacity: 0.53
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 336,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.49
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 718,
    cy: 336,
    r: 4.9,
    fill: "#548A85",
    fillOpacity: 0.43
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 336,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.36
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 336,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.3
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 886,
    cy: 336,
    r: 4.5,
    fill: "#548A85",
    fillOpacity: 0.23
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 336,
    r: 4.3,
    fill: "#548A85",
    fillOpacity: 0.15
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 388,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 388,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.39
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 388,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.46
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 388,
    r: 5.1,
    fill: "#548A85",
    fillOpacity: 0.53
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 388,
    r: 9,
    fill: "#83ADA9",
    fillOpacity: 0.95
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 388,
    r: 9,
    fill: "#83ADA9",
    fillOpacity: 0.95
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 606,
    cy: 388,
    r: 9,
    fill: "#83ADA9",
    fillOpacity: 0.95
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 388,
    r: 5.1,
    fill: "#548A85",
    fillOpacity: 0.53
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 718,
    cy: 388,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.46
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 388,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.39
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 388,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 886,
    cy: 388,
    r: 4.5,
    fill: "#548A85",
    fillOpacity: 0.24
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 388,
    r: 4.4,
    fill: "#548A85",
    fillOpacity: 0.17
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 440,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 440,
    r: 4.9,
    fill: "#548A85",
    fillOpacity: 0.4
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 440,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.47
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 440,
    r: 5.2,
    fill: "#548A85",
    fillOpacity: 0.55
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 440,
    r: 9,
    fill: "#83ADA9",
    fillOpacity: 0.95
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 440,
    r: 17,
    fill: "#FF4804"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 606,
    cy: 440,
    r: 9,
    fill: "#83ADA9",
    fillOpacity: 0.95
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 440,
    r: 5.2,
    fill: "#548A85",
    fillOpacity: 0.55
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 718,
    cy: 440,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.47
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 440,
    r: 4.9,
    fill: "#548A85",
    fillOpacity: 0.4
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 440,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 886,
    cy: 440,
    r: 4.5,
    fill: "#548A85",
    fillOpacity: 0.25
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 440,
    r: 4.4,
    fill: "#548A85",
    fillOpacity: 0.17
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 492,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 492,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.39
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 492,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.46
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 492,
    r: 5.1,
    fill: "#548A85",
    fillOpacity: 0.53
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 492,
    r: 9,
    fill: "#83ADA9",
    fillOpacity: 0.95
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 492,
    r: 9,
    fill: "#83ADA9",
    fillOpacity: 0.95
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 606,
    cy: 492,
    r: 9,
    fill: "#83ADA9",
    fillOpacity: 0.95
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 492,
    r: 5.1,
    fill: "#548A85",
    fillOpacity: 0.53
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 718,
    cy: 492,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.46
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 492,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.39
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 492,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 886,
    cy: 492,
    r: 4.5,
    fill: "#548A85",
    fillOpacity: 0.24
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 492,
    r: 4.4,
    fill: "#548A85",
    fillOpacity: 0.17
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 544,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.3
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 544,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.36
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 544,
    r: 4.9,
    fill: "#548A85",
    fillOpacity: 0.43
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 544,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.49
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 544,
    r: 5.1,
    fill: "#548A85",
    fillOpacity: 0.53
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 544,
    r: 5.2,
    fill: "#548A85",
    fillOpacity: 0.55
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 606,
    cy: 544,
    r: 5.1,
    fill: "#548A85",
    fillOpacity: 0.53
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 544,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.49
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 718,
    cy: 544,
    r: 4.9,
    fill: "#548A85",
    fillOpacity: 0.43
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 544,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.36
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 544,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.3
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 886,
    cy: 544,
    r: 4.5,
    fill: "#548A85",
    fillOpacity: 0.23
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 544,
    r: 4.3,
    fill: "#548A85",
    fillOpacity: 0.15
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 596,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.26
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 596,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 596,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.38
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 596,
    r: 4.9,
    fill: "#548A85",
    fillOpacity: 0.43
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 596,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.46
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 596,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.47
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 606,
    cy: 596,
    r: 5,
    fill: "#548A85",
    fillOpacity: 0.46
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 596,
    r: 4.9,
    fill: "#548A85",
    fillOpacity: 0.43
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 718,
    cy: 596,
    r: 4.8,
    fill: "#548A85",
    fillOpacity: 0.38
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 596,
    r: 4.7,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 596,
    r: 4.6,
    fill: "#548A85",
    fillOpacity: 0.26
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 886,
    cy: 596,
    r: 4.4,
    fill: "#548A85",
    fillOpacity: 0.2
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 596,
    r: 4.3,
    fill: "#548A85",
    fillOpacity: 0.13
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 440,
    r: 46,
    fill: "none",
    stroke: "#FF4804",
    strokeOpacity: 0.45,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceUiUxDesign);
export default __webpack_public_path__ + "static/media/service-ui-ux-design.9117605e0e44fc4b7e92c81d877a0ff6.svg";
export { ForwardRef as ReactComponent };